import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelLabel, HotelLabelEnum } from '@core/models/domains/hotel';
import { CountDownComponent } from "@shared/components/countDown/count-down.component";

@Component({
 selector: 'iho-hotel-labels',
 standalone: true,
 imports: [CommonModule, CountDownComponent],
 templateUrl: './hotel-labels.component.html',
 styleUrls: ['./hotel-labels.component.scss'],
})
export class HotelLabelsComponent {
    @Input() data!: HotelLabel
    @Output() onItemClick = new EventEmitter<boolean>()
    hotelLabelEnum = HotelLabelEnum
}
